export const styles = theme => ({
  customWidth: {
    width: `50%`,
  },
  selectWidth: {
    width: '44%',
    marginRight: '2%',
  },
  currencyWidth: {
    width: '54%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  checkBox: {
    display: 'flex',
  },
  plans: {
    padding: theme.spacing(2),
  },
  buttonAddPlan: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
  },
  itemsPaper: {
    marginTop: theme.spacing(2),
  },
})

export default styles
